import { render, staticRenderFns } from "./DimensionsAndWeightProductForm.vue?vue&type=template&id=1e7639e7&scoped=true"
import script from "./DimensionsAndWeightProductForm.vue?vue&type=script&lang=js"
export * from "./DimensionsAndWeightProductForm.vue?vue&type=script&lang=js"
import style0 from "./DimensionsAndWeightProductForm.vue?vue&type=style&index=0&id=1e7639e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7639e7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow,VSpacer})
